import { compose } from 'redux';
import { WithFetchDatasByIdFromCMS, WithFetchDatasByIdFromCMSInputProps } from 'modules/shared-cms/hocs';
import { TrendBlocContainerOwnProps } from 'modules/shared-cms-catalogue/components';
import { WithFetchProducts } from 'modules/shared-cms-catalogue/hocs';
import { CmsProductListProps } from 'modules/shared-cms-catalogue/types';

import { QUERY } from './nouveautes-catalogue-query';
import { NouveautesCatalogueLoader } from './nouveautes-catalogue-component-loader';

const enhancer = compose<React.ComponentType<WithFetchDatasByIdFromCMSInputProps>>(
    WithFetchDatasByIdFromCMS<TrendBlocContainerOwnProps & CmsProductListProps>(
        QUERY,
        NouveautesCatalogueLoader,
        'findNouveautesContent',
    ),
    WithFetchProducts(NouveautesCatalogueLoader),
);

export default enhancer;
